<template>
  <el-dialog
      :visible.sync="dialogVisible"
      title="审批"
      width="500px"
      top="5vh"
      height="30vh">
    <el-form
        ref="form"
        :model="taskApprove"
        class="form"
        label-width="120px"
        :rules="ruleValidate">
      <el-row>
        <el-col :span="18">
          <el-form-item label="审批状态:" prop="approveStatus">
            <el-select v-model="taskApprove.approveStatus">
              <el-option label="不满意" :value="10"/>
              <el-option label="及格" :value="15"/>
              <el-option label="满意" :value="20"/>
              <el-option label="非常满意" :value="30"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="审批结果:" prop="approveDesc">
            <el-input v-model="taskApprove.approveDesc" type="textarea" placeholder="请输入审批结果"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name:"TaskApprove",
    data() {
      return {
        dialogVisible:false,
        taskApprove:{
          pkid:"",
          approveStatus:"",
          approveDesc:"",
        },
        ruleValidate:{
          approveStatus:{required:true,message:"请选择审批状态！", trigger:"change"},
        },
      };
    },
    methods:{
      open(item) {
        console.log(item[0].pkId);
        this.dialogVisible = true;
        this.taskApprove.pkid = item[0].pkId;
      },
      handleSubmit() {
        this.$refs.form.validate((valid)=>{
          if(valid) {
            console.log(this.taskApprove);
            this.$http.post("basic","tasks/approveTask",this.taskApprove).then((res)=>{
              if(res.success) {
                this.$message.success("审批成功");
                this.$emit("save-success");
                this.dialogVisible = false;
              }
            }).catch(()=>{
              this.$message.error("审批失败");
              this.dialogVisible = false;
            });
          }
        });
      },
    },
  };
</script>

<style>

</style>